import React from "react";
import { View, StyleSheet, ViewStyle, StyleProp } from "react-native";
import { radius, spacing, fonts } from "~/styles/tokens";
import { useTheme } from "~/styles/theme";
import { Text } from "./Text";

type BadgeVariant = "default" | "success" | "warning" | "error";

interface BadgeProps {
  label: string;
  variant?: BadgeVariant;
  style?: StyleProp<ViewStyle>;
}

export const Badge: React.FC<BadgeProps> = ({
  label,
  variant = "default",
  style,
}) => {
  const { colors } = useTheme();

  const surface =
    variant === "success"
      ? colors.successSurface
      : variant === "warning"
        ? colors.warningSurface
        : variant === "error"
          ? colors.dangerSurface
          : colors.surfaceMuted;
  const textColor =
    variant === "success"
      ? colors.success
      : variant === "warning"
        ? colors.warning
        : variant === "error"
          ? colors.danger
          : colors.heading;

  return (
    <View style={[styles.base, { backgroundColor: surface }, style]}>
      <Text style={[styles.text, { color: textColor }]}>{label}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  base: {
    borderRadius: radius.full,
    paddingHorizontal: spacing.sm + 2,
    paddingVertical: 4,
    alignSelf: "flex-start",
  },
  text: {
    fontFamily: fonts.bodySemibold,
    fontSize: 12,
    lineHeight: 16,
  },
});
